const bgImage = require.context('./images', false, /^\.\/bg\.(jpg|jpeg|png)$/);
const bgImagePath = bgImage.keys()[0]; // Assuming there is only one background image
const bgImageSrc = bgImage(bgImagePath);

const bannerImage = require.context('./images', false, /^\.\/banner\.(jpg|jpeg|png)$/);
const bannerImagePath = bannerImage.keys()[0]; // Assuming there is only one banner image
const bannerImageSrc = bannerImage(bannerImagePath);

const logoImage = require.context('./images', false, /^\.\/logo\.(jpg|jpeg|png)$/);
const logoImagePath = logoImage.keys()[0]; // Assuming there is only one logo image
const logoImageSrc = logoImage(logoImagePath);

const images = [];
const imageContext = require.context('./images', false, /^\.\/image\d+\.(jpg|jpeg|png)$/);
imageContext.keys().forEach((imagePath, index) => {
    images.push(imageContext(imagePath));
});

const bgVideo = require.context('./images', false, /^\.\/bgVideo\.(jpg|jpeg|png)$/);
const bgVideoImagePath = bgVideo.keys()[0]; // Assuming there is only one banner image
const bgVideoImageSrc = bgVideo(bgVideoImagePath);

export { bgImageSrc, bannerImageSrc, logoImageSrc, images, bgVideoImageSrc };
